import { ModalActions, ModalContent, ModalOverlay } from "./style";

interface Props {
  onConfirm: () => void;
  onCancel: () => void;
}

export const FileSizeModal = ({ onConfirm, onCancel }: Props) => {
  return (
    <ModalOverlay>
      <ModalContent>
        <h3>Arquivo excedeu o limite de envio</h3>
        <p>O arquivo selecionado ultrapassa 50MB e não pode ser enviado diretamente pelo WhatsApp.</p>
        <p>Deseja convertê-lo em um link para compartilhamento?</p>
        <ModalActions>
          <button className="confirm" onClick={onConfirm}>Sim, enviar como link</button>
          <button className="cancel" onClick={onCancel}>Cancelar</button>
        </ModalActions>
      </ModalContent>
    </ModalOverlay>
  );
};

